
const state = {
  mdmManager: false,
  sapRoles: null,
  userInfo: {},
  isCheckRole: false,
  customerInfo: {}
}

const mutations = {
  SET_CHECKEROLE: (state, flag) => {
    state.isCheckRole = !!flag
  },
  SET_MDMMANAGER: (state, flag) => {
    state.mdmManager = flag
  },
  SET_SAPROLES: (state, roles) => {
    state.sapRoles = roles
  },
  SET_USERINFO(state, userInfo) {
    Object.assign(state.userInfo, userInfo)
  },
  SET_CUSTOMER_INFO(state, customer) {
    state.customerInfo = customer
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/user.js